import React from "react";
import { Navbar } from "react-bootstrap";
import { PALETTE } from "../ThemeConstants";

const isiOS = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

const isRunningStandalone = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};

const isInWebAppiOS = () => {
  return window.navigator.standalone === true;
};

function NavbarResponsive({ children, dark = false }) {
  const nonStandaloneStyle = {
    width: "100%",
    zIndex: 1000,
    position: "fixed",
    alignItems: "center",
    background: dark && PALETTE.VERTICALLINEARGRADIENTTRANSPARENTDARK,
  };

  const standaloneStyle = {
    background: dark && PALETTE.VERTICALLINEARGRADIENTTRANSPARENTDARK,
  };

  return (
    <Navbar
      onContextMenu={(e) => e.preventDefault()}
      expand="lg"
      className={dark ? "" : "blur"}
      style={
        isRunningStandalone() && !isiOS() ? nonStandaloneStyle : standaloneStyle
      }
    >
      {children}
    </Navbar>
  );
}

export { NavbarResponsive, isiOS, isRunningStandalone, isInWebAppiOS };
